<template>
  <div class="information">
    <h2 class="information__heading">
      {{ t(content.heading) }}
      <!-- <app-image
        svg="<svg id='Ebene_1' data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' width='246' height='431' viewBox='0 0 246 431'> <path d='M3,40.5v40' fill='#575756' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='243' y1='40.5' x2='243' y2='80.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='3' y1='60.5' x2='243' y2='60.5' fill='#fff' stroke='#009fe3' stroke-linecap='round' stroke-miterlimit='10'/> <g> <line x1='23' y1='.5' x2='83' y2='60.5' fill='#fff'/> <g> <line x1='23' y1='.5' x2='80.86624' y2='58.36625' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <path d='M83,60.5c-1.37656-.63148-3.25793-1.24158-4.7034-1.3405l2.28964-1.07327,1.07291-2.28928c.09892,1.44546,.70903,3.32683,1.34085,4.70305Z' fill='#e6332a'/> </g> </g> <line x1='83' y1='190.5' x2='83' y2='110.5' fill='#fff' stroke='#878787' stroke-dasharray='0 3' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='8' y1='130.5' x2='8' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='13' y1='130.5' x2='13' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='18' y1='130.5' x2='18' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='23' y1='130.5' x2='23' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='28' y1='130.5' x2='28' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='33' y1='130.5' x2='33' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='38' y1='130.5' x2='38' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='43' y1='130.5' x2='43' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='48' y1='130.5' x2='48' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='53' y1='130.5' x2='53' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='58' y1='130.5' x2='58' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='63' y1='130.5' x2='63' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='68' y1='130.5' x2='68' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='73' y1='130.5' x2='73' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='78' y1='130.5' x2='78' y2='170.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <polyline points='243 130.5 13 130.5 3 130.5' fill='#fff' stroke='#009fe3' stroke-linecap='round' stroke-miterlimit='10'/> <polyline points='3 170.5 83 170.5 83 130.5 245.5 130.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <circle cx='43' cy='150.5' r='7.5' fill='#000' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <path d='M43,148v5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='40.5' y1='150.5' x2='45.5' y2='150.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='243' y1='220.5' x2='243' y2='310.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='8' y1='240.5' x2='8' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='13' y1='240.5' x2='13' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='18' y1='240.5' x2='18' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='23' y1='240.5' x2='23' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='28' y1='240.5' x2='28' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='33' y1='240.5' x2='33' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='38' y1='240.5' x2='38' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='43' y1='240.5' x2='43' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='48' y1='240.5' x2='48' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='53' y1='240.5' x2='53' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='58' y1='240.5' x2='58' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='63' y1='240.5' x2='63' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='68' y1='240.5' x2='68' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='73' y1='240.5' x2='73' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='78' y1='240.5' x2='78' y2='280.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='88' y1='280.5' x2='88' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='93' y1='280.5' x2='93' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='128' y1='280.5' x2='128' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='133' y1='280.5' x2='133' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='138' y1='280.5' x2='138' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='143' y1='280.5' x2='143' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='148' y1='280.5' x2='148' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='153' y1='280.5' x2='153' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='158' y1='280.5' x2='158' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='163' y1='280.5' x2='163' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='168' y1='280.5' x2='168' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='173' y1='280.5' x2='173' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='178' y1='280.5' x2='178' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='183' y1='280.5' x2='183' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='188' y1='280.5' x2='188' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='193' y1='280.5' x2='193' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='198' y1='280.5' x2='198' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='203' y1='280.5' x2='203' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='208' y1='280.5' x2='208' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='213' y1='280.5' x2='213' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='218' y1='280.5' x2='218' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='223' y1='280.5' x2='223' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='228' y1='280.5' x2='228' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='233' y1='280.5' x2='233' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='238' y1='280.5' x2='238' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='98' y1='280.5' x2='98' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='103' y1='280.5' x2='103' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='108' y1='280.5' x2='108' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='113' y1='280.5' x2='113' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='118' y1='280.5' x2='118' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='123' y1='280.5' x2='123' y2='300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='243' y1='280.5' x2='3' y2='280.5' fill='#fff' stroke='#009fe3' stroke-linecap='round' stroke-miterlimit='10'/> <circle cx='43' cy='260.5' r='7.5' fill='#000' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <circle cx='163' cy='290.5' r='7.5' fill='#000' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='43' y1='258' x2='43' y2='263' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='40.5' y1='260.5' x2='45.5' y2='260.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='160.5' y1='290.5' x2='165.5' y2='290.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='83' y1='220.5' x2='83' y2='310.5' fill='#fff' stroke='#878787' stroke-dasharray='0 3' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='3' y1='110.5' x2='3' y2='190.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <path d='M3,220.5v90' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='243' y1='110.5' x2='243' y2='190.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='243' y1='340.5' x2='243' y2='430.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='83' y1='340.5' x2='83' y2='430.5' fill='#fff' stroke='#878787' stroke-dasharray='0 3' stroke-linecap='round' stroke-miterlimit='10'/> <polyline points='3 350.5 83 410.5 243 350.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='3' y1='340.5' x2='3' y2='430.5' fill='#fff' stroke='#878787' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='7.75906' y1='353.9129' x2='7.81448' y2='350.47664' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='12.85802' y1='350.58749' x2='12.85802' y2='357.51543' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='17.84613' y1='350.67062' x2='17.84613' y2='361.33965' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='22.9451' y1='350.6152' x2='22.9451' y2='365.27472' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='27.9055' y1='350.64291' x2='27.87779' y2='369.09894' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='32.8659' y1='350.58749' x2='32.8659' y2='372.81231' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='37.85402' y1='350.58749' x2='37.90944' y2='376.69196' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='42.89756' y1='350.58749' x2='42.95298' y2='380.21135' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='47.74712' y1='350.72605' x2='47.91339' y2='383.78617' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='52.92921' y1='350.8646' x2='52.98464' y2='387.88751' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='57.72335' y1='350.78147' x2='57.86191' y2='391.35148' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='62.87773' y1='350.83689' x2='62.90545' y2='395.4251' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='67.86585' y1='350.78147' x2='67.86585' y2='398.88907' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='72.96481' y1='350.6152' x2='73.10337' y2='402.74101' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <path d='M77.86979,350.58749c0,.22169,.05542,55.75605,.05542,55.75605' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='83.02418' y1='350.47664' x2='83' y2='410.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='87.45806' y1='408.33878' x2='87.67975' y2='350.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='92.88956' y1='350.58749' x2='92.77871' y2='406.78692' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='97.76683' y1='350.69833' x2='97.76683' y2='404.79168' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='102.75495' y1='350.47664' x2='102.75495' y2='402.90728' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='107.63221' y1='350.58749' x2='107.96476' y2='400.80118' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='112.73118' y1='350.69833' x2='112.92516' y2='398.97221' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='117.94099' y1='350.58749' x2='117.85785' y2='397.25408' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='122.81826' y1='350.58749' x2='122.9291' y2='395.23112' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='127.80637' y1='350.58749' x2='127.80637' y2='393.70697' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='132.90533' y1='350.69833' x2='132.90533' y2='391.71173' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='137.7826' y1='350.69833' x2='137.86574' y2='389.63335' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='142.77072' y1='350.58749' x2='142.99241' y2='387.61039' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='147.75883' y1='350.58749' x2='147.75883' y2='385.72599' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='152.74695' y1='350.58749' x2='152.8578' y2='384.17413' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='157.84591' y1='350.58749' x2='157.84591' y2='382.06804' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='162.83403' y1='350.58749' x2='163.05572' y2='380.18364' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='167.60045' y1='350.80918' x2='167.68358' y2='378.4378' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='172.94882' y1='350.67062' x2='172.94882' y2='376.47026' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <path d='M177.77066,374.75214c.11085-.33254-.08314-24.0538-.08314-24.0538' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='182.78649' y1='350.69833' x2='182.89734' y2='372.75689' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='187.7746' y1='350.69833' x2='187.88545' y2='371.09418' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='192.76272' y1='350.80918' x2='192.98441' y2='368.98809' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='197.75084' y1='350.69833' x2='197.97253' y2='366.882' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='202.8498' y1='350.58749' x2='203.07149' y2='365.33014' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='207.72707' y1='350.58749' x2='207.83791' y2='363.22405' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='212.82603' y1='350.58749' x2='212.93688' y2='361.45049' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='217.7033' y1='350.64291' x2='217.81414' y2='359.45525' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='222.80226' y1='350.69833' x2='222.91311' y2='357.90339' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='227.98436' y1='355.85272' x2='227.90122' y2='350.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='233.16646' y1='350.67062' x2='233.22188' y2='353.6912' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='237.9883' y1='350.67062' x2='237.9883' y2='351.97307' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <polyline points='243 350.5 227.90122 350.5 87.67975 350.5 82.80248 350.5 27.9332 350.5 15.5 350.5 3 350.5' fill='#fff' stroke='#009fe3' stroke-linecap='round' stroke-miterlimit='10'/> <circle cx='83' cy='380.5' r='7.5' fill='#000' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='83' y1='378' x2='83' y2='383' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='80.5' y1='380.5' x2='85.5' y2='380.5' fill='#fff' stroke='#e6332a' stroke-linecap='round' stroke-miterlimit='10'/> <line x1='83' y1='40.5' x2='83' y2='80.5' fill='#fff' stroke='#878787' stroke-dasharray='0 3' stroke-linecap='round' stroke-miterlimit='10'/> <polyline points='.5 240.5 83 240.5 83 300.5 245.5 300.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='.5' y1='170.5' x2='3' y2='170.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> <line x1='3' y1='410.5' x2='.5' y2='410.5' fill='none' stroke='#e6332a' stroke-linecap='round' stroke-linejoin='round'/> </svg>"
        :imageData="{
          position: [280, -20],
          width: 360,
          height: 720,
          scale: 1.35
        }"
        :imageText="[
          {
            text: '$N(x)$',
            position: [-41, 123],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: { de: '$10.963 N$', en: '$10,\\!963 N$' },
            position: [-66, 164],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: { de: '$3.254 N$', en: '$3,\\!254 N$' },
            position: [-56, 235],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: '$Q(x)$',
            position: [-41, 272],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: { de: '$1.627 N$', en: '$1,\\!627 N$' },
            position: [252.5, 294.5],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: '$M(x)$',
            position: [-41, 344],
            fontSize: 13,
            color: '#e6332a'
          },
          {
            text: { de: '$6.508 Nm$', en: '$6,\\!508 N$' },
            position: [-65, 404],
            fontSize: 13,
            color: '#e6332a'
          }
        ]"
      ></app-image> -->
    </h2>
    <div
      v-for="(paragraph, paragraphNumber) in content.contents"
      :key="paragraph + 'andParagraphNumber' + paragraphNumber"
      class="information__paragraph-container"
      :class="'information__paragraph-container--' + paragraph.style"
    >
      <div
        v-if="paragraph.label !== undefined"
        class="information__paragraph-label"
      >
        {{ t(paragraph.label) }}
      </div>
      <p
        v-if="!Array.isArray(paragraph.text)"
        class="information__paragraph-text"
        style="white-space: pre-line;"
      >
        {{ t(paragraph.text) }}
      </p>
      <ul
        v-if="Array.isArray(paragraph.text)"
        class="information__paragraph-text information__paragraph-text--list-style"
      >
        <li
          v-for="(listItem, index) in paragraph.text"
          :key="listItem + 'andIndex' + index"
        >
          {{ t(listItem) }}
        </li>
      </ul>
      <template
        v-if="
          'images' in content &&
            typeof content.images[paragraphNumber] === 'object' &&
            'image' in content.images[paragraphNumber]
        "
      >
        <app-image
          :svg="content.images[paragraphNumber].image"
          :imageData="content.images[paragraphNumber].imageData"
          :arrows="content.images[paragraphNumber].arrows"
          :imageText="content.images[paragraphNumber].imageText"
        ></app-image>
      </template>
    </div>
    <!-- <div class="information__paragraph-container">
      <app-glossary-link
        text="Wir benötigen für die Rechnung die ##Definition[cosine, geometry, definition]## des Cosinus am rechtwinkligen Dreieck. Außerdem brauchen wir die ##Reihendarstellung[cosine, row, formula]## des Cosinus."
        textNumber="0"
      ></app-glossary-link>
    </div> -->
    <app-button
      @mousedown="setPage('++')"
      @touchstart="setPage('++')"
      size="big"
      :text="$t(getButton)"
      class="information__continue-button"
    ></app-button>
  </div>
</template>

<script>
import AppButton from "@/components/Atoms/Button.vue";
// import AppGlossaryLink from "@/components/Molecules/GlossaryLink.vue";
import AppImage from "@/components/Organisms/Image.vue";

export default {
  name: "information",
  props: {
    content: Object
  },
  components: {
    AppButton,
    // AppGlossaryLink
    AppImage
  },
  computed: {
    getButton() {
      if (this.content.button === "exercise") {
        return "course_exercise_button";
      } else {
        return "course_continue_button";
      }
    }
  },
  created() {
    this.$store.dispatch("setExerciseStatus", [0, 4]);
  }
};
</script>

<style lang="scss" scoped>
@import "sass/main.scss";

.information {
  position: absolute;
  top: 6rem;
  width: 100%;
  min-height: calc(100vh - 6rem);
  padding-top: 5.5rem;
  color: $color-white;
  // background-color: #101010;
  // background-color: #131313;
  // background-color: $color-black;
  background-color: #101010;
  overflow: hidden;

  display: grid;
  @include grid-template-columns;
  align-content: start;

  @include respond(phone) {
    padding-top: 4.6rem;
    min-height: 100vh;
    background-color: $color-black;
  }

  &__heading {
    grid-column: 3 / 4;
    margin-bottom: 4.125rem;
    font-weight: 400;
    text-align: center;

    @include respond(tab-land) {
      margin-bottom: 3.78rem;
      line-height: 1.2;
    }

    @include respond(phone) {
      grid-column: 1 / 6;
      margin-bottom: 3.6rem;
      font-size: 4rem;
    }
  }

  &__paragraph-container {
    position: relative;
    grid-column: 3 / 4;
    font-size: 2.8rem;

    &:not(:last-child) {
      margin-bottom: 4.5rem;
    }

    &:nth-last-child(2) {
      margin-bottom: 19rem;
    }

    &--blueBorder {
      margin-top: 1.625rem;
      width: max-content;
      // width: 100%;
      border: 1px solid $color-primary;
      border-radius: 0.6rem;
      border-top-left-radius: 0;
      font-size: 2.6rem;
      color: $color-primary-light;

      /* @include respond(phone) {
        width: 100%;
      } */

      &:not(:last-child) {
        margin-bottom: 6rem;
      }

      & .information__paragraph-text {
        // padding: 1rem 2rem 0.8rem;
        padding: 1rem 1.625rem 0.8rem;
      }
    }

    &--orangeBorder {
      margin-top: 1.625rem;
      width: max-content;
      border: 1px solid orange;
      // border: 1px solid $color-secondary-light;
      border-radius: 0.6rem;
      border-top-left-radius: 0;
      font-size: 2.6rem;
      color: orange;
      // color: $color-secondary-light;

      @include respond(phone) {
        width: 100%;
      }

      &:not(:last-child) {
        margin-bottom: 6rem;
      }

      & .information__paragraph-text {
        padding: 1rem 2rem 0.8rem;
      }
    }

    &--bold {
      font-family: $font-primary-bold;
      color: $color-primary-light;
      margin-bottom: 0 !important;
      // margin-bottom: -4.5rem !important;
    }

    &--italic {
      font-style: italic;
      // color: $color-primary-light;
    }
  }

  &__paragraph-label {
    position: absolute;
    left: -1px;
    transform: translateY(-100%);
    // width: min-content;
    padding: 0.3rem 2rem;
    margin-bottom: 1rem;
    font-family: $font-primary-bold;
    font-size: 2.2rem;
    line-height: 1;
    border-top-left-radius: 0.4rem;
    border-top-right-radius: 0.4rem;
    background-color: $color-primary;

    .information__paragraph-container--blueBorder & {
      color: $color-white;
    }

    .information__paragraph-container--orangeBorder & {
      color: $color-black;
      background-color: orange;
      // background-color: $color-secondary-light;
    }
  }

  &__paragraph-text {
    max-width: calc(100vw - 1.5rem);
    transform: translateZ(1px); // Removes artefacts from Mathjax formulas

    &--list-style {
      margin-left: 2rem;
    }
  }

  /* &__continue-button {
    grid-column: 1 / 4;
    // grid-row: 5 / 6;
    width: max-content;
    height: max-content;
    left: calc(50vw + 0.5 * min(#{$width-center}, 100vw - 6rem));
    transform: translateX(-100%);
    border: 1px solid transparent !important;
    border-radius: 0.6rem;
    padding: 0.85rem 2.4rem !important;
    background-color: $color-primary-dark;

    transform-style: preserve-3d;

    &::after {
      @include pseudo-element;
      left: -0.75rem;
      top: calc(-1.1rem - 1px);
      transform: translateZ(-1px);
      width: 100vw;
      height: 8.2rem;
      backdrop-filter: blur(10px);
    }

    @include respond(phone) {
      position: fixed;
      display: block;
      // left: 0.75rem;
      left: 0;
      top: 0;
      // transform: translateY(calc(var(--vh, 1vh) * 100 - 13.85rem + 1px));
      transform: translateY(calc(var(--vh, 1vh) * 100 - 13.5rem + 1px));
      // width: calc(100vw - 1.5rem);
      width: 100vw;
      height: 6rem;
      font-size: 2.8rem;
      text-align: center;
      // background-color: #1876b8;
      will-change: transform;
      transition: transform 0.75s;

      // background-color: #222;
      // background-color: #202020;
    }
  } */

  &__continue-button {
    // visibility: hidden;
    position: fixed;
    left: calc(50vw + 0.5 * min(#{$width-center}, 100vw - 6rem));
    top: calc(100 * var(--vh) - 7.5rem);
    transform: translate(-100%, -100%);
    // transform: translateY(calc(var(--vh, 1vh) * 100 - 13.5rem + 1px));
    width: max-content;
    height: max-content;
    border: 1px solid transparent !important;
    border-radius: 0.6rem;
    // padding: 0.85rem 2.4rem !important;
    padding: 1rem 3.2rem !important;
    background-color: $color-primary-dark;

    @include respond(phone) {
      // position: fixed;
      display: block;
      left: 0;
      top: 0;
      // transform: translateY(calc(var(--vh, 1vh) * 100 - 6.5rem + 1px));
      transform: translateY(calc(var(--vh, 1vh) * 100 - 13.5rem + 1px));
      width: 100vw;
      height: 6rem;
      font-size: 2.8rem;
      text-align: center;
      // visibility: hidden;
      will-change: transform;
      transition: transform 0.75s;
    }
  }
}
</style>
